
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'checkout-address-billing',
  components: {
    CheckoutAddressForm: require('./input/AddressForm.vue').default,
    CheckoutAddressSelect: require('./input/AddressSelect.vue').default,
  },
})
export default class extends Vue {
  @Prop({ required: false }) private addresses: Array<object>;
  @Prop({default: false}) private isB2b: boolean;

  private manualForm: boolean = false;
  private selectedAddress: object = {};
  private differentAddress: boolean = false;

  private get billingAddress(): object {
    return this.$store.state['CheckoutAddress']['billingAddress'];
  }

  private get showForm(): boolean {
    const hasSavedAddresses = Array.isArray(this.addresses) && this.addresses.length > 0;
    if (hasSavedAddresses) {
      return ('newAddress' in this.selectedAddress) || this.manualForm;
    }

    return this.billingAddress.hasOwnProperty('newAddress') || this.manualForm || Object.keys(this.selectedAddress).length === 0;
  }

  created(): void {
    if (this.addresses.length > 0) {
      const defaultBilling =
        this.addresses.find((address) => address['default_billing']) ?? this.addresses[0];
      this.selectedAddress = defaultBilling;
    }
  }
  @Watch('selectedAddress')
  private handler(nv, ov): void {
    if (nv === ov) {
      return;
    }

    this.$store.dispatch('CheckoutAddress/setBillingAddress', {
      address: nv,
    });

    if (nv && 'newAddress' in nv) {
      this.differentAddress = false;
    }
  }
}
